import { Pipe, PipeTransform } from '@angular/core';

import { Record } from '../models/record/record.class';
import { RecordField } from '../models/record/recordfield.class';

@Pipe({
    name: 'PrimarySubHeaderRecordFields',
    standalone: false,
})
export class PrimarySubHeaderRecordFieldsPipe implements PipeTransform {
    transform(fields: RecordField[], record: Record): RecordField[] {
        if ((record.showInListCount as number) > 0) {
            return fields?.filter(field => !field.showInList);
        }
        return fields?.filter(field => field.preCaptureType !== 'FILING' && !field.isBusinessKey && !field.isMandatory);
    }
}
